var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-container" }, [
    _c("div", { staticClass: "header-area" }, [
      _c("h1", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("analytics.transactions_header")) +
            "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-area transactions" },
      [_c("TopTransactions", { attrs: { "with-search": true } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }